var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-success-page" },
    [
      _c(
        "v-app",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { "max-width": "600px" } },
                [
                  _c("v-card-text", [
                    _c(
                      "div",
                      [
                        _c(
                          "v-layout",
                          { staticClass: "test-success-warning" },
                          [
                            _c(
                              "v-avatar",
                              {
                                attrs: {
                                  color:
                                    _vm.title == "SuccessPage"
                                      ? "green"
                                      : "red",
                                  size: "70"
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "white", size: "50" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.title == "SuccessPage"
                                          ? "check"
                                          : "close"
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { staticClass: "test-success-warning mt-2" },
                          [
                            _c("strong", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.title == "SuccessPage"
                                      ? "All Done For Now!"
                                      : "Error!"
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { staticClass: "test-success-warning mt-2" },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.title == "SuccessPage"
                                      ? "Success! Please close this tab."
                                      : "Test failed in Callback Validation. Please check your configuration."
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }